import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "collapse-inner" }
const _hoisted_2 = { class: "collapse-inner" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Transition, { duration: $props.duration }, {
    default: _withCtx(() => [
      ($props.keepAlive)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["collapse-wrapper", {horizontal: $props.horizontal, vertical: !$props.horizontal, opacity: $props.opacity}])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
          ], 2 /* CLASS */)), [
            [_vShow, $props.open]
          ])
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($props.open)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["collapse-wrapper", {horizontal: $props.horizontal, vertical: !$props.horizontal, opacity: $props.opacity}])
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                  ])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["duration"]))
}